import React from 'react';

interface DateFieldProps {
    id: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}

const DateField: React.FC<DateFieldProps> = ({ id, value, onChange, disabled }) => (
    <input
        type="date"
        id={id}
        value={value}
        onChange={onChange}
        className="h-10 w-full rounded border border-slate-200 px-4 text-sm text-slate-500 
        dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 outline-none transition-all 
        focus:border-primary dark:focus:border-primary disabled:cursor-not-allowed"
        disabled={disabled}
    />
);

export default DateField;
